import React, { ReactNode } from 'react'

import {
  Container,
  Wrapper,
  Arrow,
} from './styles'

type IProps = {
  text: string;
  color: string;
  children: ReactNode;
}

const Tooltip = ({ children, text, color = '#000' }: IProps) => (
  <Container>
    <Wrapper style={{ color }}>
      {text}
      <Arrow />
    </Wrapper>
    {children}
  </Container>
)

export default Tooltip
